module.exports = __webpack_public_path__ + "static/ogimg-contact-f0eca1ed2688ab283544674fcbee639b.jpg";